import script from "./PrintBoxCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintBoxCode.vue?vue&type=script&lang=ts&setup=true"

import "./PrintBoxCode.vue?vue&type=style&index=0&id=6a88e7c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a88e7c6"]])

export default __exports__